<template>
    <canvas ref="canvas"></canvas>
</template>

<script>
export default {
    name: "ExportComp",
    props: {
        canvas: {
            type: Object,
            required: false
        }
    }
}
</script>

<style scoped>
canvas {
    position: absolute;
    display: none;
}
</style>